export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Footer.vue?vue&type=template&id=27f46840&"


//////////////////
// WEBPACK FOOTER
// ./src/components/Layout/Footer.vue?vue&type=template&id=27f46840&
// module id = null
// module chunks = 